import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="py-10 text-sm text-white/60">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <Logo />
          <nav className="flex gap-4">
            <a href="/about" className="hover:text-white">
              About
            </a>
            <a href="/services" className="hover:text-white">
              Services
            </a>
            <a href="/contact" className="hover:text-white">
              Contact
            </a>
          </nav>
        </div>
        <p className="mt-6">
          Risk Warning: CFDs are complex instruments and come with a high risk
          of losing money rapidly due to leverage.
        </p>
        <p className="mt-2">
          © {new Date().getFullYear()} KESTREN. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
